import { useState } from "react";
import { toast } from "react-toastify";
import ProductService from "../../../rest/productService";

export function useProductSelection(pagedData) {
    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectAll = (e) => {
        if (e.target.checked && pagedData) {
            setSelectedItems(pagedData.map(item => item.product_id));
        } else {
            setSelectedItems([]);
        }
    };

    const handleSelectItem = (id) => {
        setSelectedItems(prev =>
            prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
        );
    };

    const clearSelection = () => setSelectedItems([]);

    const updateBatchStatus = async (isActive) => {
        try {
            const payload = {
                ids: selectedItems,
                active: isActive
            };

            await ProductService.updateBatchStatus(payload);

            toast.success(`Status atualizado com sucesso!`);
            clearSelection();
        } catch (error) {
            console.error(error);
            toast.error("Erro ao atualizar status.");
        }
    };

    return {
        selectedItems,
        handleSelectAll,
        handleSelectItem,
        clearSelection,
        actions: {
            updateBatchStatus
        }
    };
}